export const applyOilPaintingEffect = async (canvas, ctx, setMessage, language) => {
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 유화 효과: 두꺼운 붓터치와 색상 혼합
  // 1. 색상 강화 (유화의 진한 색감)
  for (let i = 0; i < data.length; i += 4) {
    const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
    // 채도 증가
    data[i] = Math.min(255, avg + (data[i] - avg) * 1.3);
    data[i + 1] = Math.min(255, avg + (data[i + 1] - avg) * 1.3);
    data[i + 2] = Math.min(255, avg + (data[i + 2] - avg) * 1.3);
    
    // 콘트라스트 증가
    for (let c = 0; c < 3; c++) {
      const value = data[i + c];
      data[i + c] = value < 128 ? value * 0.9 : Math.min(255, value * 1.1);
    }
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 붓터치 효과 (Oil painting brush strokes)
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  
  const brushData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const brushPixels = brushData.data;
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  // 붓터치 시뮬레이션 (클러스터링 효과)
  const brushSize = 3;
  for (let y = brushSize; y < canvas.height - brushSize; y += 2) {
    for (let x = brushSize; x < canvas.width - brushSize; x += 2) {
      // 주변 픽셀들의 평균 색상 계산
      let avgR = 0, avgG = 0, avgB = 0;
      let count = 0;
      
      for (let dy = -brushSize; dy <= brushSize; dy++) {
        for (let dx = -brushSize; dx <= brushSize; dx++) {
          const pos = ((y + dy) * canvas.width + (x + dx)) * 4;
          avgR += tempData[pos];
          avgG += tempData[pos + 1];
          avgB += tempData[pos + 2];
          count++;
        }
      }
      
      avgR /= count;
      avgG /= count;
      avgB /= count;
      
      // 붓터치 영역에 평균 색상 적용
      for (let dy = -brushSize; dy <= brushSize; dy++) {
        for (let dx = -brushSize; dx <= brushSize; dx++) {
          if (Math.abs(dx) + Math.abs(dy) <= brushSize) {
            const pos = ((y + dy) * canvas.width + (x + dx)) * 4;
            brushPixels[pos] = avgR;
            brushPixels[pos + 1] = avgG;
            brushPixels[pos + 2] = avgB;
          }
        }
      }
    }
  }
  
  ctx.putImageData(brushData, 0, 0);
  
  // 3. 임파스토 효과 (두꺼운 물감 질감)
  const impastoData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const impastoPixels = impastoData.data;
  
  for (let i = 0; i < impastoPixels.length; i += 4) {
    // 랜덤한 질감 추가
    if (Math.random() > 0.92) {
      const textureStrength = (Math.random() - 0.5) * 40;
      for (let c = 0; c < 3; c++) {
        impastoPixels[i + c] = Math.min(255, Math.max(0, impastoPixels[i + c] + textureStrength));
      }
    }
  }
  
  ctx.putImageData(impastoData, 0, 0);
};